import React from 'react';

import * as styles from './Divider.styles';

export const Divider = ({ text }: { text?: string }) => (
  <p css={styles.dividerOuter}>{text && <span css={styles.dividerInner}>{text}</span>}</p>
);
